import { dsStudioDataModifier } from '@wix/a11y-adapters/studio';
import { copyHeadingTagContent } from '@wix/rules-panel-ui';
import { getEditorCapabilitiesForHost } from '../../utils/editor-host-to-editor-type';
const DESKTOP_COMPONENT_TYPE = 'DESKTOP';
export const headingStructureOnApply = async (newTag, oldTag, oldHeadingHtmlString, oldHeadingCompId, uiElementId, adapter, editorHost, isFixHeadingStructureWithAiEnabled, attributeId) => {
  const normalizedNewTag = newTag.toLowerCase();
  const parser = new DOMParser();
  const doc = parser.parseFromString(oldHeadingHtmlString, 'text/html');
  const oldHeadingElement = doc.querySelector(oldTag);
  if (!oldHeadingElement) {
    throw new Error(`Old heading tag <${oldTag}> not found in provided HTML`);
  }
  const newHeadingHtmlString = copyHeadingTagContent(normalizedNewTag, oldHeadingElement);
  if (!isFixHeadingStructureWithAiEnabled && getEditorCapabilitiesForHost(editorHost).compactPanelChrome) {
    if (adapter.isBuilderRichTextComponent != null && adapter.isBuilderRichTextComponent({
      id: oldHeadingCompId,
      type: DESKTOP_COMPONENT_TYPE
    })) {
      adapter.setHTMLTagForBuilderRichTextComponent == null || adapter.setHTMLTagForBuilderRichTextComponent(normalizedNewTag);
    } else {
      throw new Error(`Heading with id ${oldHeadingCompId} is not a builder rich text component`);
    }
  } else {
    let headingStudioComponent;
    try {
      headingStudioComponent = adapter.getComponent({
        id: oldHeadingCompId,
        type: DESKTOP_COMPONENT_TYPE
      });
    } catch (err) {
      throw new Error(`Component with id ${oldHeadingCompId} not found`);
    }
    const {
      data: updatedData
    } = dsStudioDataModifier.updateTextHeadingLevel(headingStudioComponent, normalizedNewTag);
    if (!updatedData) {
      throw new Error('Failed to update heading level - missing data');
    }
    adapter.setComponentData({
      id: oldHeadingCompId,
      type: DESKTOP_COMPONENT_TYPE
    }, {
      ...updatedData
    });
  }
  return {
    attributeId,
    htmlString: newHeadingHtmlString,
    id: oldHeadingCompId,
    uiElementId
  };
};
//# sourceMappingURL=heading-structure-on-apply.js.map